import { render, staticRenderFns } from "./title_area.vue.js?vue&type=template&id=9666a826!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./title_area.vue?vue&type=template&id=9666a826"
import script from "./title_area.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./title_area.vue?vue&type=script&lang=js"
export * from "./title_area.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./title_area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports